export async function getSampleRes() {

    const response = await fetch('/api/sample');
    return await response.json()
}